import { render } from "./SectionsSubMenuWorkPlan.vue?vue&type=template&id=6e6af39b"
import script from "./SectionsSubMenuWorkPlan.vue?vue&type=script&lang=js"
export * from "./SectionsSubMenuWorkPlan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__